import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

const ImageCard = ({ parentClass, imgSrc, title, customClass, imgClass, hrefUrl }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);


  if (!isMounted) return null;
  return (
    <div className="flex flex-col justify-center items-center">
      <div className={parentClass && parentClass}>
        {/* <Link href={hrefUrl || ""}> */}
        {imgSrc && (
          <Image
            src={imgSrc}
            alt={title}
            width={200}
            height={200}
            loading="lazy"
            className={`mb-5 lg:mb-[1.5vw] ${imgClass && imgClass}`}
          />
        )}
        {/* </Link> */}
      </div>
      {hrefUrl && title ?
        <Link href={hrefUrl || ""} >
          <div className={customClass}>{title}</div>
        </Link> :
        title && <div className={customClass}>{title}</div>
      }
    </div>
  );
};

export default ImageCard;
